import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { AiIntegrationView } from "../../../useSearchAiIntegrations/gql";

const IntegrationsAiTableModelCell = ({
  item,
  ...cellProps
}: TableSimpleCellProps<AiIntegrationView>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <TableCellText>{item.model}</TableCellText>
    </TableSimpleCell>
  );
};

export default IntegrationsAiTableModelCell;
